import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-bold font-heading text-background-50 mb-4">黑料在线</h4>
              <p className="text-sm text-background-300 leading-relaxed">
                最新最全的视频内容平台，汇聚热门资讯与精彩视频，免费在线观看，高清流畅体验。
              </p>
            </div>

            <div>
              <h4 className="text-base font-semibold text-background-50 mb-4">热门分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(0, 6).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-base font-semibold text-background-50 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">首页</Link>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors">关于我们</Link>
                <Link to="/category/hot" className="text-sm text-background-300 hover:text-primary-400 transition-colors">热门推荐</Link>
                <Link to="/category/celebrity" className="text-sm text-background-300 hover:text-primary-400 transition-colors">明星八卦</Link>
              </div>
            </div>

            <div>
              <h4 className="text-base font-semibold text-background-50 mb-4">联系方式</h4>
              <div className="flex flex-col gap-3 text-sm text-background-300">
                <div className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>contact@heiliao-online.com</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-888-0000</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-primary-400"></i>
                  <span>北京市朝阳区媒体大道88号</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-400">
                &copy; {currentYear} 黑料在线 HeiliaoOnline.com 版权所有 | 京ICP备2024XXXXXXXX号
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors" rel="nofollow">隐私政策</a>
                <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors" rel="nofollow">用户协议</a>
                <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors" rel="nofollow">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}